/**
 * Generate up-to-two-character initials from a name string.
 * Single-word names pad with the second letter so avatars always render
 * a 2-character glyph (e.g. "Alex" → "AL", "Cher" → "CH").
 * Missing/empty input returns ''; backend payloads can legitimately omit a name.
 */
export function getUserInitials(name: string | null | undefined): string {
  if (!name) return '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return parts
    .map(p => p[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

/**
 * Format account creation date
 */
export function formatAccountDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  });
}
